<uc-main-header
	heading="Hundreds of our advice articles for you to read about university"
	description="Our advice section provides study tips, student advice, gap year advice, personal statement tips and advice and guidance for teachers."
	backgroundStyle="bg-advice"
>
	<div class="py-6">
		<uc-search-bar
			redirectTo="/advice/search"
			[displayButton]="true"
			placeholder="Search Articles"
		/>
	</div>
</uc-main-header>

<!-- loading -->
@if (isLoading) {
	<div class="container divider !border-b-0">
		<uc-loading-animation [htmlString]="loadingHtml" />
	</div>
}

<!-- Advice Main Content -->
@if (articles$ | async) {
	<div class="container pt-8 bg-white sm:pt-0">
		@if (featured) {
			<div>
				<!-- featured article: 1 main article -->
				@if (featured.featured_article.art_id) {
					<div class="divider">
						<h2 class="secondary-header">Featured Article</h2>
						<uc-advice-featured-card [article]="featured.featured_article" />
					</div>
				}
				<!-- editor's choice: 3 articles -->
				<div class="divider">
					<h2 class="secondary-header">Editor's Choice</h2>
					<div class="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-4">
						@for (article of featured.editors_choice; track article) {
							<uc-advice-article-card [article]="article" />
						}
					</div>
				</div>
				<!-- snigel google ads -->
				<div class="divider">
					<div class="sm:hidden">
						<div
							id="adngin-incontent_1_mob-0"
							class="mx-auto incontent_1_mob-0"
						></div>
					</div>
					<div class="hidden sm:block">
						<div
							id="adngin-incontent_1_dskt-0"
							class="mx-auto incontent_1_dskt-0"
						></div>
					</div>
				</div>
				<!-- snigel ends -->
			</div>
		}

		<!-- categories -->
		<div class="divider-top md:grid md:grid-cols-3 md:gap-10 lg:gap-20">
			<div class="md:col-span-2">
				@if (articles) {
					<uc-table-search
						heading="Article Categories"
						[subHeading]="tableSearchDescription()"
						[resultCount]="categoryMeta.length"
						[showSearch]="false"
					>
						@for (
							category of categoryMeta;
							track category.key;
							let last = $last
						) {
							<uc-advice-category-card
								[categoryName]="category.catTitle"
								[categoryDesc]="category.catDescription"
								[categorySlug]="category.url"
								[isLast]="last"
								[articleCount]="articles[category.key]?.length ?? 0"
							/>
						}
					</uc-table-search>
				}
			</div>

			<div
				class="pt-8 pb-8 mt-8 border-t border-b md:border-b-0 md:pt-0 md:mt-0 md:border-0 md:col-span-1 md:block"
			>
				<div class="sticky top-8">
					<uc-promo-slot-cta-card />
				</div>
			</div>
		</div>

		<!-- promo slots -->
		<uc-promo-slots headline="Find the latest from Uni Compare" [section]="1" />
	</div>
}

<uc-sticky-lead-bar-renderer leadType="BOOK_EVENT" colorScheme="ROSE" />
